import {
	AppError,
	buildMailtoLink,
	dateToString,
	ErrorType,
	generateEmailBody,
	timestampToUTCTime,
} from '@agilox/common';
import { ButtonComponent } from '@agilox/ui';
import { DOCUMENT } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

const SUPPORT_MAIL_RECIPIENT = 'support@agilox.net';

@Component({
	selector: 'ui-error-content',
	templateUrl: './error-content.component.html',
	imports: [ButtonComponent, TranslateModule],
})
export class ErrorContentComponent {
	private document = inject(DOCUMENT);
	private translate = inject(TranslateService);

	error = input.required<AppError>();
	emailExtras = input<{ [key: string]: string }>({});

	closed = output<void>();

	emailBody = computed(() => {
		const date = new Date();

		const obj = {
			[this.translate.instant('general.error_description')]: this.translate.instant(
				'general.error_description_here'
			),
			app: this.error().application,
			user: this.error().user?.email,
			url: this.error().url,
			error: this.error().message,
			body: this.error().body,
			type: this.error().type,
			date: dateToString(date),
			'time (UTC)': timestampToUTCTime(date.getTime()),
			page: this.document.defaultView?.location.href,
			...this.emailExtras(),
		};

		return generateEmailBody(obj);
	});

	supportMailto = computed(() => {
		const subject = `Error at application: ${this.error().application?.toUpperCase() ?? ''}`;
		return buildMailtoLink(SUPPORT_MAIL_RECIPIENT, subject, this.emailBody());
	});

	protected readonly ErrorType = ErrorType;

	reload() {
		this.document.defaultView?.location.reload();
	}

	public close() {
		this.closed.emit();
	}
}
